import React, { useCallback, useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import { useDispatch } from "react-redux";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../../../../../redux/loader/loaderActions";
import baseUrl from "../../../../../../../../api/baseUrl";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
interface FormData {
  roleName: string;
  routePermission: number[];
  actionPermission: number[];
}
const tdata = [
  {
    KEY: "1",
    lable: "Patient complain",
  },
  {
    KEY: "2",
    lable: "Investigation",
  },
  {
    KEY: "3",
    lable: "Diagnosis",
  },
  {
    KEY: "4",
    lable: "treatments",
  },
  {
    KEY: "5",
    lable: "Payments",
  },
];
function ReportModal({ setReportOpen }: any) {
  const dispatch = useDispatch();
  const { ID } = useParams();
  const [formData, setformData] = useState<any>(["1"]);
  useEffect(() => {
    const storedData = localStorage.getItem("reportData");

    if (storedData) {
      console.log(JSON.parse(storedData));
      setformData(JSON.parse(storedData));
    }
  }, []);
  const handleChange = (e: any) => {
    const { name, value, checked } = e.target;

    if (checked) {
      const newData = [...formData, value];
      setformData(newData);
      const jsonArray = JSON.stringify(newData);
      localStorage.setItem("reportData", jsonArray);
    } else {
      
      const newData = formData.filter((key: number) => key !== value);
      setformData(newData);
      const jsonArray = JSON.stringify(newData);
      localStorage.setItem("reportData", jsonArray);
    }
  };
  const generate = useCallback(
    (e: any) => {
      e.preventDefault();
      dispatch(setloadeActive());
      baseUrl
        .get("/client/report/patientReport", {
          responseType: "blob",
          headers: { treatmentid: ID, data: formData },
        })
        .then((response) => {
          if (response.status === 204) {
            toast("No data found");
            return;
          }
          const pdfBlob = new Blob([response.data], {
            type: "application/pdf",
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(pdfBlob);
          link.download = "downloaded.pdf";
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        })
        .catch(console.error)
        .finally(() => dispatch(setloadeDeactive()));
    },
    [dispatch, formData]
  );

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 border-b border-slate-100 dark:border-slate-700 flex items-center justify-between bg-gradient-to-r from-primary to-primaryLight">
          <div className="flex items-center gap-3">
            <DescriptionIcon className="text-white" />
            <h2 className="text-xl font-bold text-white">Generate Report</h2>
          </div>
          <button
            onClick={() => setReportOpen(false)}
            className="w-8 h-8 rounded-lg bg-white/20 hover:bg-white/30 flex items-center justify-center text-white transition-colors"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={generate} className="p-6 space-y-3">
          <p className="text-sm text-slate-600 dark:text-slate-400 mb-4">Select sections to include in the report:</p>
          
          {tdata.map((item: any, i) => (
            <label
              key={i}
              className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-all ${
                formData.includes(item.KEY)
                  ? "bg-indigo-50 dark:bg-primary/20 border-2 border-indigo-500 dark:border-primary"
                  : "bg-slate-50 dark:bg-slate-700/50 border-2 border-transparent hover:bg-slate-100 dark:hover:bg-slate-700"
              }`}
            >
              <input
                type="checkbox"
                onChange={handleChange}
                name={item?.lable}
                value={item.KEY}
                checked={formData.includes(item.KEY)}
                className="sr-only"
              />
              <div
                className={`w-5 h-5 rounded-md flex items-center justify-center ${
                  formData.includes(item.KEY)
                    ? "bg-indigo-500 dark:bg-primary text-white"
                    : "bg-white dark:bg-slate-600 border-2 border-slate-300 dark:border-slate-500"
                }`}
              >
                {formData.includes(item.KEY) && (
                  <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
              <span className="text-sm font-medium text-slate-700 dark:text-slate-300">{item?.lable}</span>
            </label>
          ))}

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full mt-4 py-3 rounded-xl bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all"
          >
            Generate Report
          </button>
        </form>
      </div>
    </div>
  );
}

export default ReportModal;
